import { render, staticRenderFns } from "./UnpublishButton.vue?vue&type=template&id=6f8b2c34&scoped=true&"
import script from "./UnpublishButton.vue?vue&type=script&lang=js&"
export * from "./UnpublishButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b2c34",
  null
  
)

export default component.exports